export default __webpack_public_path__ + "images/0xa500000000e482752f032ea387390b6025a2377b.png";